export const parseInstString = (instString) => {
    //console.log(instString);
    if (!instString) return {};

    const result = {};

    const tokens = instString.split(" ");

    if (tokens.length === 1) {
        return parseSingleInst(tokens[0]);
    }
        
    const items = [];
    var operator = "";

    var i = 0;
    var expectingConjunction = false;
    while (i < tokens.length) {
        const token = tokens[i];
        if (expectingConjunction) {
            if (!["AND", "OR", "THEN"].includes(token)) {
                return {};
            }

            if (operator === "") {
                operator = token;
            } else if (operator !== token) {
                return {};
            }
        } else {
            if (token === "[") {
                const openBracketIdx = i;
                var bracketCount = 1;
                while (bracketCount > 0) {
                    i++;
                    if (i >= tokens.length) {
                        return {};
                    }
                    if (tokens[i] === "[") bracketCount++;
                    if (tokens[i] === "]") bracketCount--;
                }
                
                items.push(parseInstString(tokens.slice(openBracketIdx + 1, i).join(" ")));
            } else {
                items.push(parseSingleInst(token));
            }
        }

        expectingConjunction = !expectingConjunction;
        i++;
    }

    if (operator === "") {
        // sometimes there's an extra set of brackets around the whole inst string
        // so we get one extra superset with no operator... this will fix
        return items[0];
    }

    result.type = "set";
    result.operator = operator;
    result.items = items;

    return result;

};

const parseSingleInst = (inst) => {
    const regex = /#\d+#/g;

    if (regex.test(inst)) {
        return {
            type: "inst",
            id: parseInt(inst.slice(1,-1))
        };
    } else {
        return {};
    }
};

export const instrumentationCursorCap = (insts) => {
    if (!insts || !insts.type) return 0;

    if (insts.type === "inst") {
        return 1;
    } else {
        return 2 + insts.items.length + insts.items.reduce((prev, curr) => prev + instrumentationCursorCap(curr), 0);
    }
}

// is the cursor location one where a new instrument can be inserted? or is it some existing item?
export const isCursorAdding = (insts, cursor) => {
    if (!insts || !insts.type) return true;

    if (insts.type !== "set") return false;

    if (cursor >= instrumentationCursorCap(insts)) return false;

    if (cursor === 0) return false;

    if (cursor === 1) return true;

    let counter = 2;
    let i = 0;
    while (i < insts.items.length) {
        const item = insts.items[i];
        const len = instrumentationCursorCap(item);
        if ((cursor - counter) < len) {
            return isCursorAdding(item, cursor - counter);
        }
        counter += len;
        if ((cursor - counter) === 0) {
            return true;
        }
        counter += 1;
        i++;
    }

    return false;
}

export const addOrReplaceItemAt = (item, insts, cursor) => {
    if (!insts || !item || !item.type) return;

    if (cursor <= 0) {
        insts.type = item.type;
        if (insts.type === "set") {
            insts.items = item.items;
            insts.operator = item.operator;
        } else if (insts.type === "inst") {
            insts.id = item.id;
        }
    } else if (insts.type === "set") {
        if (cursor === 1) {
            insts.items.splice(0,0,item);
            return;
        }
        let i = 0;
        let counter = 2;
        while (i < insts.items.length) {
            const oldItem = insts.items[i];
            const len = instrumentationCursorCap(oldItem);
            if ((cursor - counter) < len) {
                addOrReplaceItemAt(item, oldItem, cursor - counter);
                return;
            }
            counter += len;
            if ((cursor - counter) === 0) {
                insts.items.splice(i + 1, 0, item);
                return;
            }
            counter += 1;
            i++;
        }
    }
}

export const deleteItemAt = (insts, cursor) => {
    if (!insts || !insts.type) return;

    if (insts.type === "inst") return;

    let i = 0;
    let counter = 2;
    while (i < insts.items.length) {
        if (cursor - counter === 0) {
            insts.items.splice(i, 1);
            return;
        }
        const item = insts.items[i];
        const len = instrumentationCursorCap(item);
        if ((cursor - counter) < len) {
            deleteItemAt(item, cursor - counter);
        }
        counter += len + 1;
        i++;
    }
}

export const validateInsts = (insts) => {
    if (!insts || !insts.type) return false;

    if (insts.type === "inst") return true;

    if (insts.items.length === 0) return false;

    return insts.items.every(validateInsts);
}

export const constructInstrumentationString = (insts) => {
    if (!insts || !insts.type) return;

    if (insts.type === "inst") return `#${insts.id}#`;

    let result = "[ ";
    let i = 0;
    while (i < insts.items.length) {
        const item = insts.items[i];
        if (i > 0) {
            result += `${insts.operator} `;
        }
        const itemStr = constructInstrumentationString(item);
        result += `${itemStr} `;
        i++;
    }
    result += "]";
    return result;
};